import ProgramExplorer from './ProgramExplorer';

const PROGRAMS = [
  {
    icon: 'role-play',
    title: 'Business Communication & Executive Presence',
    desc: 'Clear, confident communication and the executive presence that helps leaders and the teams who work with clients influence outcomes.',
    tags: ['Executive presence', 'Structured messaging', 'Stakeholder influence'],
  },
  {
    icon: 'coaching',
    title: 'Stress Management',
    desc: 'Practical techniques to manage pressure, prevent burnout and stay focused and effective under demanding workloads.',
    tags: ['Wellbeing', 'Focus under pressure', 'Work-life balance'],
  },
  {
    icon: 'bar-growth',
    title: 'Leadership Development & Emotional Intelligence',
    desc: 'Grow emotionally intelligent leaders who know themselves, read the room, inspire teams and turn people potential into performance.',
    tags: ['EQ at work', 'People leadership', 'Coaching mindset'],
  },
  {
    icon: 'coaching',
    title: 'Conflict Resolution & Difficult Conversations',
    desc: 'Equip managers to navigate tension, deliver hard feedback and resolve disagreement with composure instead of avoidance.',
    tags: ['Candid feedback', 'Negotiation', 'Composure under pressure'],
  },
  {
    icon: 'award-ribbon',
    title: 'POSH Awareness & Internal Committee Capacity Building',
    desc: 'Certified POSH awareness and Internal Committee training that builds a safe, respectful and legally compliant workplace.',
    tags: ['Compliance', 'IC readiness', 'Safe workplace'],
  },
  {
    icon: 'workshop',
    title: 'Customer Service Excellence & Workplace Productivity',
    desc: 'A mindset that puts service first, paired with practical productivity habits that lift everyday effectiveness across the organisation.',
    tags: ['Service mindset', 'Prioritisation', 'Ownership'],
  },
];

export default function ForCorporates() {
  return (
    <ProgramExplorer
      id="for-corporates"
      variant="dark"
      eyebrow="CORPORATE TRAINING & CONSULTING"
      title="For Corporates"
      intro="Communication, leadership, behavioural and workplace effectiveness programmes that sharpen individual performance and organisational impact, customised to your business goals."
      programs={PROGRAMS}
      ctaText="Enquire for corporate programs"
      ctaClass="btn-primary"
    />
  );
}
